import React, { useState } from 'react';

import css from './HelpExplainer.module.css';

/**
 * sections: [
 *   { key: 'update', icon: Edit, title: 'Update Quote - button will appear here', items: [...] },
 *   { key: 'send', icon: Check, title: 'Send Quote - Button will appear here below update quote' }
 * ]
 *
 * If openOnClick is true, the box opens/closes on click. Otherwise it opens on hover.
 */
export default function HelpExplainer({
  trigger = '?',
  intro,
  texts = [],
  sections = [],
  openOnClick = true,
  className = '',
}) {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(v => !v);

  const contentClassName = [css.helpContent, open ? css.open : ''].join(' ').trim();

  return (
    <div
      className={`${css.helpExplainerContainer} ${className}`}
      onClick={openOnClick ? toggleOpen : undefined}
      role={openOnClick ? 'button' : undefined}
      tabIndex={openOnClick ? 0 : undefined}
      onKeyDown={
        openOnClick
          ? e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleOpen();
              }
            }
          : undefined
      }
    >
      <div className={css.helpIcon} aria-hidden>
        {trigger}
      </div>

      <div className={contentClassName}>
        <div className={css.helpHeader}>
          <div className={css.helpIconLarge}>{trigger}</div>
        </div>

        <p className={css.helpIntro}>{intro}</p>

        {texts.map((t, i) => (
          <p className={css.helpText} key={i}>
            {t}
          </p>
        ))}

        {sections.map(s => (
          <div className={css.helpSection} key={s.key}>
            <div className={css.helpSectionHeader}>
              {s.icon ? <s.icon className={css.helpSectionIcon} /> : null}
              <span className={css.helpSectionTitle}>{s.title}</span>
            </div>

            {s.items && s.items.length > 0 && (
              <ul className={css.helpList}>
                {s.items.map((it, idx) => (
                  <li key={idx}>{it}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
